import { Component, Input, Output, EventEmitter, InputSignal, input } from "@angular/core";

@Component({
  selector: "app-checkbox",
  templateUrl: "./checkbox.component.html",
})
export class CheckboxComponent {
  @Input() title: string;
  @Input() background = "primary";
  @Input() checked = false;
  @Input() disabled = false;
  customisedBoxSize: InputSignal<string> = input("");
  isMobile: InputSignal<boolean> = input(false); // Controls glow shadow appearance
  @Output() onChange = new EventEmitter<boolean>();

  toggle() {
    if (!this.disabled) {
      this.checked = !this.checked;
      this.onChange.emit(this.checked);
    }
  }
}
